module.exports = __webpack_public_path__ + "media/images/app/products/necklaces_red_currant-9795ef0eb7ba20b4c8ac89155a3f704b.webp";